var map = {
	"./Solar-Space_symbol_0.png": "86dd",
	"./Solar-Space_symbol_1.png": "ce68",
	"./Solar-Space_symbol_2.png": "5112",
	"./Solar-Space_symbol_3.png": "148a",
	"./Solar-Space_symbol_4.png": "20ca",
	"./Solar-Space_symbol_5.png": "9522",
	"./Solar-Space_symbol_6.png": "cd2a",
	"./Solar-Space_symbol_7.png": "50ea",
	"./Solar-Space_symbol_8.png": "4efa",
	"./Solar-Space_symbol_9.png": "001b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0a7";